<div class="permissions-toolbar">
    <mat-form-field class="filter-field" appearance="outline">
        <mat-label>Filter permissions</mat-label>
        <input matInput [(ngModel)]="filter" (ngModelChange)="applyFilter()" placeholder="Company, grantee, grantor, role">
        <button *ngIf="filter" matSuffix mat-icon-button type="button" aria-label="Clear filter" (click)="clearFilter()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <mat-button-toggle-group [value]="displayMode" (change)="setDisplayMode($event.value)" aria-label="Permission display mode">
        <mat-button-toggle value="rows">Rows</mat-button-toggle>
        <mat-button-toggle value="grantee">By Grantee</mat-button-toggle>
    </mat-button-toggle-group>
    <button mat-raised-button color="primary" type="button" (click)="addGrantee()">Add Grantee</button>
</div>

<div *ngIf="!loading && permissions.data.length === 0" class="empty-state">You do not have any permissions granted.</div>
<div *ngIf="!loading && permissions.data.length > 0 && permissions.filteredData.length === 0" class="empty-state">No permissions match this filter.</div>

<table *ngIf="displayMode === 'rows'" class="table" mat-table matSort #permissionSort="matSort" [dataSource]="permissions">
    <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Created At</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.createdAt | date: 'medium'}}</td>
    </ng-container>
    <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Company</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.companyName}}</td>
    </ng-container>
    <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Role</th>
        <td class="cell" mat-cell *matCellDef="let item">{{getRoleLabel(item.role)}}</td>
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Grantee</th>
        <td class="cell" mat-cell *matCellDef="let item">
            <a *ngIf="item.email" [href]="'mailto:'+item.email">{{item.name}}</a>
            <span *ngIf="!item.email">{{item.name}}</span>
        </td>
    </ng-container>
    <ng-container matColumnDef="grantorName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Grantor</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.grantorName}}</td>
    </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td class="cell actions-cell" mat-cell *matCellDef="let item">
            <button type="button" mat-button [matMenuTriggerFor]="permissionMenu" [matMenuTriggerData]="{item: item}">
                <mat-icon matTooltip="Actions" class="more">more_vert</mat-icon>
            </button>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: columnsToDisplay"></tr>
</table>

<table *ngIf="displayMode === 'grantee'" class="table" mat-table matSort #granteeSort="matSort" [dataSource]="granteePermissions">
    <ng-container matColumnDef="granteeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Grantee</th>
        <td class="cell grantee-cell" mat-cell *matCellDef="let group">
            <a *ngIf="group.granteeEmail" [href]="'mailto:'+group.granteeEmail">{{group.granteeName}}</a>
            <span *ngIf="!group.granteeEmail">{{group.granteeName}}</span>
            <span *ngIf="group.granteeEmail" class="secondary-text">{{group.granteeEmail}}</span>
        </td>
    </ng-container>
    <ng-container matColumnDef="permissionCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Permissions</th>
        <td class="cell" mat-cell *matCellDef="let group">{{group.permissionCount}}</td>
    </ng-container>
    <ng-container matColumnDef="permissions">
        <th mat-header-cell *matHeaderCellDef>Company Permissions</th>
        <td class="cell permission-list-cell" mat-cell *matCellDef="let group">
            <div class="permission-list">
                <div *ngFor="let permission of group.permissions; trackBy: trackByPermissionId" class="permission-item">
                    <div class="permission-copy">
                        <span class="company-name">{{permission.companyName}}</span>
                        <span class="permission-meta">
                            {{getRoleLabel(permission.role)}}
                            <span *ngIf="getGrantorName(permission) || getGrantorEmail(permission)">
                                granted by
                                <a *ngIf="getGrantorEmail(permission)" [href]="'mailto:'+getGrantorEmail(permission)">{{getGrantorName(permission)}}</a>
                                <span *ngIf="!getGrantorEmail(permission)">{{getGrantorName(permission)}}</span>
                                <span *ngIf="getGrantorEmail(permission)" class="inline-email">{{getGrantorEmail(permission)}}</span>
                            </span>
                        </span>
                    </div>
                    <button type="button" mat-icon-button [matMenuTriggerFor]="permissionMenu" [matMenuTriggerData]="{item: permission}" aria-label="Change permission">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </div>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="latestCreatedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Sort Ascending/Descending/None">Latest Grant</th>
        <td class="cell" mat-cell *matCellDef="let group">{{group.latestCreatedAt | date: 'medium'}}</td>
    </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td class="cell actions-cell" mat-cell *matCellDef="let group">
            <button type="button" mat-button [matMenuTriggerFor]="granteeMenu" [matMenuTriggerData]="{group: group}">
                <mat-icon matTooltip="Grantee actions" class="more">more_vert</mat-icon>
            </button>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="granteeColumnsToDisplay"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: granteeColumnsToDisplay"></tr>
</table>

<mat-menu #permissionMenu="matMenu">
    <ng-template matMenuContent let-item="item">
        <button mat-menu-item [matMenuTriggerFor]="roleMenu" [matMenuTriggerData]="{item: item}">Change Role</button>
        <button mat-menu-item (click)="removePermission(item)">Remove Permission</button>
    </ng-template>
</mat-menu>

<mat-menu #roleMenu="matMenu">
    <ng-template matMenuContent let-item="item">
        <button
            *ngFor="let role of roleOptions"
            mat-menu-item
            [disabled]="item.role === role.value"
            (click)="updatePermissionRole(item, role.value)">
            {{role.label}}
        </button>
    </ng-template>
</mat-menu>

<mat-menu #granteeMenu="matMenu">
    <ng-template matMenuContent let-group="group">
        <button mat-menu-item (click)="removeGrantee(group)">Remove Grantee</button>
        <button mat-menu-item (click)="addPermissionToGrantee(group)">Add Permission</button>
    </ng-template>
</mat-menu>
